import React from 'react'

import { getPasswordHint } from '@src/authorisation/children/pages/sign_up/children/sign_up_form/helpers'

import InputField from '@components/forms/input_field'
import ThemedButton from '@components/themed_button'

import { LOGIN_FALLBACK } from './constants'
import styles from './styles'

export function EmailField(props) {
  return (
    <InputField
      value={props.email}
      label={props.t('d_email_address')}
      id='email'
      inputName='email'
      type='email'
      autoComplete='username'
      valueHandler={props.emailValueHandler}
      blurHandler={props.emailBlurHandler}
      focusHandler={props.emailFocusHandler}
      error={props.emailError}
      errorAction={props.emailErrorAction}
      errorActionText={props.emailErrorActionText}
      consumerGroup={props.consumerGroup}
    />
  )
}

export function PasswordField(props) {
  return (
    <InputField
      value={props.password}
      label={props.t('d_password')}
      id='password'
      inputName='password'
      type='password'
      autoComplete='current-password'
      valueHandler={props.passwordValueHandler}
      hint={getPasswordHint(props)}
      showPasswordAriaLabel={props.t('a_toggle_show_password')}
      error={props.passwordError}
      blurHandler={props.passwordBlurHandler}
      focusHandler={props.passwordFocusHandler}
    />
  )
}

export function SubmitButton({ loading, formSubmitHandler, t, valid }) {
  return (
    <div style={styles.buttonContainer}>
      <ThemedButton
        onClick={formSubmitHandler}
        loading={loading}
        disabled={!valid}
      >
        {t('a_log_in') || LOGIN_FALLBACK}
      </ThemedButton>
    </div>
  )
}
